// 산재보험료 환급 — 업종별 프로그래매틱 SEO 랜딩 데이터.
// slug=URL, key=요율 YAML의 industry_key(계산 prefill), acQuery=사고사례 탐색기 연결어.
// 각 페이지는 업종 요율·예시·키워드가 달라 고유 콘텐츠(thin content 아님).
export interface IrIndustryPage {
  slug: string
  key: string
  label: { ko: string; en: string }
  keywords: string[]
  intro: { ko: string; en: string }
  safetyNote: { ko: string; en: string }
  acQuery: string   // ac-datacenter 검색어(해당 업종 실제 사고사례로 연결)
}

export const IR_INDUSTRIES: IrIndustryPage[] = [
  {
    slug: 'food', key: 'mfg_food',
    label: { ko: '식료품 제조업', en: 'Food manufacturing' },
    keywords: ['식료품 제조업 산재보험료', '식품공장 산재보험료 환급', '요율제 위험성평가 인정', '식품 제조 산재 할인'],
    intro: { ko: '식료품 제조 사업장은 컨베이어·절단기·고온설비 등 위험이 많아 산재보험료율이 높은 편입니다. 위험성평가 인정을 받으면 3년간 20%를 아낄 수 있습니다.',
             en: 'Food plants carry conveyor, cutter and hot-equipment hazards. Risk-assessment recognition cuts the premium 20% for 3 years.' },
    safetyNote: { ko: '끼임·베임·화상·미끄러짐이 잦습니다.', en: 'Caught-in, cuts, burns and slips are common.' },
    acQuery: '식품 제조 컨베이어 절단 작업',
  },
  {
    slug: 'textile', key: 'mfg_textile',
    label: { ko: '섬유·의류 제조업', en: 'Textile & apparel manufacturing' },
    keywords: ['섬유 제조업 산재보험료', '봉제공장 산재보험료 환급', '의류 제조 요율제', '위험성평가 인정 할인'],
    intro: { ko: '섬유·봉제 사업장은 재봉기·염색·분진 위험이 있습니다. 50인 미만이면 위험성평가 인정으로 산재보험료 20% 인하 대상입니다.',
             en: 'Textile/sewing sites face machine, dyeing and dust hazards. Under 50 workers, recognition cuts the premium 20%.' },
    safetyNote: { ko: '재봉기 끼임·분진·화학물질 노출에 주의.', en: 'Sewing-machine caught-in, dust and chemical exposure.' },
    acQuery: '섬유 봉제 재봉기 작업',
  },
  {
    slug: 'wood-paper', key: 'mfg_wood_paper',
    label: { ko: '목재·종이제품 제조업', en: 'Wood & paper products manufacturing' },
    keywords: ['목재 제조업 산재보험료', '가구공장 산재보험료 환급', '제지 요율제', '목공 위험성평가 인정'],
    intro: { ko: '목재·가구·제지 사업장은 요율이 높은 업종 중 하나입니다. 위험성평가 인정으로 3년간 20% 환급을 준비할 수 있습니다.',
             en: 'Wood, furniture and paper sites have a high premium rate. Prepare for a 20% cut via recognition.' },
    safetyNote: { ko: '목재가공기 끼임·절단, 분진 화재 위험.', en: 'Woodworking machine caught-in/cuts and dust fire risk.' },
    acQuery: '목재 가공 절단기 작업',
  },
  {
    slug: 'printing', key: 'mfg_print',
    label: { ko: '출판·인쇄·제본업', en: 'Printing & bookbinding' },
    keywords: ['인쇄업 산재보험료', '인쇄공장 산재보험료 환급', '제본 요율제', '위험성평가 인정'],
    intro: { ko: '인쇄·제본 사업장은 롤러 끼임·화학물질 위험이 있습니다. 50인 미만이면 산재보험료 20% 인하를 준비할 수 있습니다.',
             en: 'Printing/binding sites face roller caught-in and chemical hazards. Prepare for a 20% cut.' },
    safetyNote: { ko: '인쇄기 롤러 끼임, 유기용제 노출.', en: 'Press roller caught-in, solvent exposure.' },
    acQuery: '인쇄기 롤러 작업',
  },
  {
    slug: 'chemical', key: 'mfg_chem_rubber',
    label: { ko: '화학·고무제품 제조업', en: 'Chemical & rubber products' },
    keywords: ['화학 제조업 산재보험료', '고무공장 산재보험료 환급', '플라스틱 제조 요율제', '위험성평가 인정 할인'],
    intro: { ko: '화학·고무·플라스틱 사업장은 화재·폭발·화학물질 위험이 큽니다. 위험성평가 인정으로 산재보험료 20% 환급을 준비하세요.',
             en: 'Chemical/rubber/plastic sites carry fire, explosion and chemical hazards. Prepare for a 20% cut.' },
    safetyNote: { ko: '화학물질 노출·화재폭발·사출기 끼임.', en: 'Chemical exposure, fire/explosion, molding-machine caught-in.' },
    acQuery: '화학 사출 성형 작업',
  },
  {
    slug: 'pharma', key: 'mfg_pharma',
    label: { ko: '의약품·화장품·석유제품 제조업', en: 'Pharma, cosmetics & petroleum products' },
    keywords: ['의약품 제조업 산재보험료', '화장품공장 산재보험료 환급', '요율제', '위험성평가 인정'],
    intro: { ko: '의약품·화장품·석유제품 사업장도 50인 미만이면 위험성평가 인정으로 산재보험료 20% 인하 대상입니다.',
             en: 'Pharma/cosmetics/petroleum sites under 50 workers qualify for the 20% cut via recognition.' },
    safetyNote: { ko: '화학물질·분진·설비 위험.', en: 'Chemical, dust and equipment hazards.' },
    acQuery: '화장품 의약품 제조 작업',
  },
  {
    slug: 'machinery-metal', key: 'mfg_machine_metal',
    label: { ko: '기계·금속·비금속·광물제품 제조업', en: 'Machinery, metal & mineral products' },
    keywords: ['금속가공 산재보험료', '기계공장 산재보험료 환급', '주물 요율제', '제조업 위험성평가 인정', '철강 산재 할인'],
    intro: { ko: '기계·금속가공 사업장은 프레스·용접·크레인 등 위험이 많아 소규모 제조업에서 가장 흔한 요율제 대상입니다. 위험성평가 인정으로 3년간 20% 환급을 준비하세요.',
             en: 'Machinery/metalworking sites (press, welding, crane) are the most common recognition target among small manufacturers. Prepare for a 20% cut.' },
    safetyNote: { ko: '프레스 끼임·용접 화상·중량물 협착이 잦습니다.', en: 'Press caught-in, welding burns and struck-by are common.' },
    acQuery: '금속 프레스 가공 작업',
  },
  {
    slug: 'smelting', key: 'mfg_metal_smelt',
    label: { ko: '금속제련업', en: 'Metal smelting' },
    keywords: ['금속제련 산재보험료', '주조공장 산재보험료 환급', '요율제', '위험성평가 인정'],
    intro: { ko: '금속제련·주조 사업장은 고온·용융금속 위험이 큽니다. 50인 미만이면 산재보험료 20% 인하를 준비할 수 있습니다.',
             en: 'Smelting/casting sites carry molten-metal and heat hazards. Prepare for a 20% cut.' },
    safetyNote: { ko: '용융금속 화상·유해가스에 주의.', en: 'Molten-metal burns and toxic gas.' },
    acQuery: '금속 제련 용융 작업',
  },
  {
    slug: 'electronics', key: 'mfg_electric_elec',
    label: { ko: '전기·정밀·전자제품 제조업', en: 'Electrical, precision & electronics' },
    keywords: ['전자제품 제조업 산재보험료', '전기공장 산재보험료 환급', '정밀 제조 요율제', '위험성평가 인정'],
    intro: { ko: '전기·전자·정밀 사업장은 요율이 낮은 편이지만, 위험성평가 인정을 받으면 그만큼도 3년간 20% 아낄 수 있습니다.',
             en: 'Electronics/precision sites have a lower rate, but recognition still cuts it 20% for 3 years.' },
    safetyNote: { ko: '감전·화학물질·반복작업 근골격계 위험.', en: 'Electric shock, chemicals and repetitive-strain risk.' },
    acQuery: '전자제품 조립 작업',
  },
  {
    slug: 'shipbuilding', key: 'mfg_shipbuild',
    label: { ko: '선박건조·수리업', en: 'Shipbuilding & repair' },
    keywords: ['선박건조 산재보험료', '조선소 산재보험료 환급', '요율제', '위험성평가 인정 할인'],
    intro: { ko: '선박건조·수리 사업장은 요율이 높은 업종입니다. 위험성평가 인정으로 산재보험료 20% 환급을 준비하세요.',
             en: 'Shipbuilding/repair has a high premium rate. Prepare for a 20% cut via recognition.' },
    safetyNote: { ko: '고소작업 추락·용접 화재·밀폐공간 질식.', en: 'Falls, welding fire and confined-space asphyxiation.' },
    acQuery: '선박 건조 용접 고소작업',
  },
  {
    slug: 'handmade', key: 'mfg_handmade_etc',
    label: { ko: '수제품·기타제품 제조업', en: 'Handmade & other manufacturing' },
    keywords: ['제조업 산재보험료 환급', '수제품 제조 요율제', '위험성평가 인정', '소규모 공장 산재 할인'],
    intro: { ko: '기타 제조 사업장도 50인 미만이면 위험성평가 인정으로 산재보험료 20% 인하 대상입니다.',
             en: 'Other manufacturing under 50 workers qualifies for the 20% cut via recognition.' },
    safetyNote: { ko: '수공구·소형기계 사용 중 재해 주의.', en: 'Hand-tool and small-machine injuries.' },
    acQuery: '수공구 소형기계 작업',
  },
  {
    slug: 'forestry', key: 'forestry',
    label: { ko: '임업', en: 'Forestry' },
    keywords: ['임업 산재보험료', '벌목 산재보험료 환급', '산림 요율제', '위험성평가 인정 할인'],
    intro: { ko: '임업은 산재보험료율이 가장 높은 업종 중 하나(5.8%)라 20% 인하 시 절감액이 특히 큽니다. 위험성평가 인정을 준비하세요.',
             en: 'Forestry has one of the highest premium rates (5.8%), so a 20% cut saves the most. Prepare for recognition.' },
    safetyNote: { ko: '벌목 중 깔림·전도, 체인톱 베임 위험.', en: 'Struck-by/rollover during logging, chainsaw cuts.' },
    acQuery: '벌목 체인톱 작업',
  },
  {
    slug: 'sanitation', key: 'sanitation_svc',
    label: { ko: '위생 및 유사서비스업', en: 'Sanitation & similar services' },
    keywords: ['위생서비스업 산재보험료', '세탁·청소 산재보험료 환급', '소독 방역 요율제', '위험성평가 인정'],
    intro: { ko: '세탁·청소·소독·방역 등 위생 및 유사서비스업도 50인 미만이면 산재보험료 20% 인하 대상입니다.',
             en: 'Laundry, cleaning, disinfection and similar services under 50 workers qualify for the 20% cut.' },
    safetyNote: { ko: '화학약품 노출·미끄러짐·고온설비 주의.', en: 'Chemical exposure, slips and hot equipment.' },
    acQuery: '청소 소독 방역 작업',
  },
  {
    slug: 'sewage', key: 'sewage',
    label: { ko: '하수도업', en: 'Sewage' },
    keywords: ['하수도업 산재보험료', '하수처리 산재보험료 환급', '요율제', '위험성평가 인정 할인'],
    intro: { ko: '하수도업 사업장도 50인 미만이면 위험성평가 인정으로 산재보험료 20% 인하를 준비할 수 있습니다.',
             en: 'Sewage sites under 50 workers can prepare for the 20% cut via recognition.' },
    safetyNote: { ko: '밀폐공간 질식·유해가스에 특히 주의.', en: 'Confined-space asphyxiation and toxic gas.' },
    acQuery: '하수도 맨홀 밀폐공간 작업',
  },
]

export function findIndustry(slug: string): IrIndustryPage | undefined {
  return IR_INDUSTRIES.find((i) => i.slug === slug)
}
